import {$win} from '../app/globals';
import Swiper from 'swiper';
import 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initTeamSlider = function( $sectionInstance ) {
	const $slider = $sectionInstance.find( '.js-our-team-slider' );
	if ( !$slider.length || $slider[0].swiper ) {
		return;
	}

	const $wrap = $slider.closest( '.section-our-team__slider-wrap' );

	new Swiper( $slider[0], {
		slidesPerView: 1,
		spaceBetween: 20,
		speed: 600,
		watchOverflow: true,
		navigation: {
			nextEl: $wrap.find( '.swiper-button-next' )[0],
			prevEl: $wrap.find( '.swiper-button-prev' )[0],
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1025: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
			},
		},
	} );
};

const initBlock = function( $block ) {
	$block.each( function() {
		const $sectionInstance = $( this );

		if ( $sectionInstance.hasClass( 'section-our-team--slider' ) ) {
			initTeamSlider( $sectionInstance );
			return;
		}

		let $persons = $sectionInstance.find( '.person-card' );
		let $btnWrapper = $sectionInstance.find( '.section-our-team__btn-wrapper' );
		let $btn = $btnWrapper.find( '.js-our-team-more' );

		$btn.off( 'click.ourTeam' ).on( 'click.ourTeam', function() {
			if ( !$btn.hasClass( 'opened' ) ) {
				$btn.addClass( 'opened' );
				$btn.text( $btn.data( 'hide-text' ) );

				$persons.each( function( index ) {
					if ( index > 3 ) {
						$( this ).slideDown( 300 ).removeClass( 'hidden' );
					}
				} );
			} else {
				$btn.removeClass( 'opened' );
				$btn.text( $btn.data( 'more-text' ) );

				$persons.each( function( index ) {
					if ( index > 3 ) {
						$( this ).slideUp( 300 ).addClass( 'hidden' );
					}
				} );
			}
		} );

		hidePersons( $persons, $btnWrapper, $btn );

		$win.off( 'resize.ourTeam' ).on( 'resize.ourTeam', function() {
			hidePersons( $persons, $btnWrapper, $btn );
		} );
	} );
	function hidePersons( $items, $btnWrap, $btn ) {
		if ( $win[0].matchMedia( '(min-width: 1025px)' ).matches ) {
			$items.removeClass( 'hidden' ).removeAttr( 'style' );
			$btnWrap.addClass( 'hidden' );
			$btn.removeClass( 'opened' ).text( $btn.data( 'more-text' ) );
		} else if ( $items.length > 3 ) {
			$items.each( function( index ) {
				if ( index > 3 ) {
					$( this ).addClass( 'hidden' );
				}
			} );

			$btnWrap.removeClass( 'hidden' );
		}
	}
};

app.loadBlock( initBlock, 'our-team', '.section-our-team' );

if ( module.hot ) {
	module.hot.accept();
}
